import PropTypes from 'prop-types'

import moment from 'moment'
import {
  CHART_COLORS,
  CHART_DATE_FORMAT,
  CHART_UNIT,
  ChartOptions,
} from './chartConstants'

const labelStyle = {
  padding: '7px 10px 0',
  fontSize: 11,
  lineHeight: '17px',
}

const inlineBlockStyle = {
  display: 'inline-block',
}

const toTitle = dataKey =>
  ChartOptions.find(({ value }) => value === dataKey)?.text

const CustomTooltip = ({ active, payload = [], label, chartUnit }) => {
  if (payload && payload.length > 0) {
    const [left, right] = payload
    return (
      active &&
      left && (
        <div
          style={{
            fontSize: 14,
            paddingBottom: 7,
            borderRadius: 4,
            backgroundColor: '#fff',
            boxShadow: '2px 2px 10px rgba(0, 0, 0, .25)',
          }}>
          <strong
            style={{
              padding: '4px 10px 5px',
              fontSize: 10,
              color: '#333',
              textAlign: 'center',
              borderBottom: '1px solid rgba(0, 0, 0, .05)',
            }}>
            {chartUnit === CHART_UNIT.DAY
              ? moment(label, CHART_DATE_FORMAT).format(moment.HTML5_FMT.DATE)
              : `${String(label).padStart(2, '0')}시`}
            <span className="screen_out">차트 데이터</span>
          </strong>
          <dl
            style={{
              ...labelStyle,
              color: CHART_COLORS.LEFT,
            }}>
            <dt style={inlineBlockStyle}>{toTitle(left.dataKey)}:&nbsp;</dt>
            <dd style={inlineBlockStyle}>{left.value.toLocaleString()}</dd>
          </dl>
          {right && (
            <dl
              style={{
                ...labelStyle,
                color: CHART_COLORS.RIGHT,
              }}>
              <dt style={inlineBlockStyle}>{toTitle(right.dataKey)}:&nbsp;</dt>
              <dd style={inlineBlockStyle}>{right.value.toLocaleString()}</dd>
            </dl>
          )}
        </div>
      )
    )
  } else {
    return null
  }
}
CustomTooltip.propTypes = {
  active: PropTypes.any,
  payload: PropTypes.any,
  label: PropTypes.any,
  chartUnit: PropTypes.oneOf([CHART_UNIT.DAY, CHART_UNIT.HOUR]),
}
export default CustomTooltip
